import { render, staticRenderFns } from "./bgl-form.vue?vue&type=template&id=2882e006&"
import script from "./bgl-form.vue?vue&type=script&lang=js&"
export * from "./bgl-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports